'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/OptInPrompt.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptInPrompt = function (_BcReactComponent) {
  _inherits(OptInPrompt, _BcReactComponent);

  function OptInPrompt() {
    _classCallCheck(this, OptInPrompt);

    return _possibleConstructorReturn(this, (OptInPrompt.__proto__ || Object.getPrototypeOf(OptInPrompt)).apply(this, arguments));
  }

  _createClass(OptInPrompt, [{
    key: 'renderPromptInfo',
    value: function renderPromptInfo() {
      var _props = this.props,
          optedIn = _props.optedIn,
          bundle = _props.bundle,
          showAdditionalMessage = _props.showAdditionalMessage;


      if (optedIn) {
        var classNames = (0, _classnames2.default)('pull-left opt-in-cta col-xs-12 col-sm-8 col-md-9', {
          'with-additional-info': showAdditionalMessage
        });

        return _react2.default.createElement(
          'div',
          { className: classNames },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_active_' + bundle, className: 'test' }),
          showAdditionalMessage && _react2.default.createElement(
            'p',
            { className: 'text-reg' },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: 'opt_in_active_additional_' + bundle,
              defaultMessage: '' })
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'pull-left opt-in-cta col-xs-12 col-sm-7' },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_inactive_' + bundle, className: 'test' })
      );
    }
  }, {
    key: 'renderOptOutLink',
    value: function renderOptOutLink() {
      return _react2.default.createElement(
        _baseButtons.TextButton,
        {
          className: 'link-contextual',
          role: 'button',
          handleClick: this.props.handleOptOut },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_disable_' + this.props.bundle })
      );
    }
  }, {
    key: 'renderDismissLink',
    value: function renderDismissLink() {
      return _react2.default.createElement(
        _baseButtons.TextButton,
        {
          className: 'link-contextual',
          role: 'button',
          handleClick: this.props.handleDismiss },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_decline_' + this.props.bundle })
      );
    }
  }, {
    key: 'renderActions',
    value: function renderActions() {
      var _props2 = this.props,
          optedIn = _props2.optedIn,
          bundle = _props2.bundle,
          allowOptOut = _props2.allowOptOut,
          allowDismiss = _props2.allowDismiss;


      if (optedIn) {
        return _react2.default.createElement(
          'div',
          { className: 'pull-right opt-in-actions opted-in col-xs-12 col-sm-4 col-md-3' },
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            allowOptOut && this.renderOptOutLink(),
            _react2.default.createElement(
              _baseButtons.HighlightButton,
              { handleClick: this.props.handleOpenFeedback },
              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_feedback_' + bundle })
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'opt-in-actions opted-out col-xs-12 col-sm-5' },
        _react2.default.createElement(
          'div',
          { className: 'pull-right' },
          allowDismiss && this.renderDismissLink(),
          _react2.default.createElement(
            _baseButtons.HighlightButton,
            { handleClick: this.props.handleOptIn },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_accept_' + bundle })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-opt-in-prompt clearfix row' },
        this.renderPromptInfo(),
        this.renderActions()
      );
    }
  }]);

  return OptInPrompt;
}(_baseBcReactComponent2.default);

OptInPrompt.propTypes = {
  allowDismiss: _react.PropTypes.bool,
  allowOptOut: _react.PropTypes.bool,
  showAdditionalMessage: _react.PropTypes.bool,
  bundle: _react.PropTypes.string.isRequired,
  optedIn: _react.PropTypes.bool.isRequired,
  handleOptIn: _react.PropTypes.func.isRequired,
  handleDismiss: _react.PropTypes.func.isRequired,
  handleOpenFeedback: _react.PropTypes.func.isRequired,
  handleOptOut: _react.PropTypes.func.isRequired
};

OptInPrompt.defaultProps = {
  allowOptOut: true,
  allowDismiss: true,
  showAdditionalMessage: true
};

exports.default = OptInPrompt;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-prompt/components/OptInPrompt.component.js
// module id = 1440
// module chunks = 1